// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.info-row {
  margin: 0;
  padding: 0;
  display: table-row;
}

.info-cell {
  margin: 0;
  padding: 0;
  display: table-cell;
}

.info-section {
  margin: 0;
  padding: 0 0 0.5rem 0;
  width: 100%;
}

.sub {
  padding-left: 0.5rem !important;
}

.info-item {
  margin: 0;
  padding: 0 0 0.5rem 0.5rem;
  list-style: none;
}

.cert_valid {
  color: green;
}

.cert_outdated {
  color: red;
}

.information_integrity_valid {
  color: green;
}

.information_integrity_error {
  color: red;
}

.information_integrity_notChecked {
  color: gray;
}`, "",{"version":3,"sources":["webpack://./src/webid/4.0/projects/controls/src/lib/dev/info/info.component.scss"],"names":[],"mappings":"AAGA;EACE,SAAA;EACA,UAAA;EACA,kBAAA;AAFF;;AAKA;EACE,SAAA;EACA,UAAA;EACA,mBAAA;AAFF;;AAKA;EACE,SAAA;EACA,qBAAA;EACA,WAAA;AAFF;;AAKA;EACE,+BAAA;AAFF;;AAKA;EACE,SAAA;EACA,0BAAA;EACA,gBAAA;AAFF;;AAKA;EACE,YAAA;AAFF;;AAKA;EACE,UAAA;AAFF;;AAKA;EACE,YAAA;AAFF;;AAKA;EACE,UAAA;AAFF;;AAKA;EACE,WAAA;AAFF","sourcesContent":["$indent: 0.5rem;\n$vspacing: 0.5rem;\n\n.info-row {\n  margin: 0;\n  padding: 0;\n  display: table-row;\n}\n\n.info-cell {\n  margin: 0;\n  padding: 0;\n  display: table-cell;\n}\n\n.info-section {\n  margin: 0;\n  padding: 0 0 $vspacing 0;\n  width: 100%;\n}\n\n.sub {\n  padding-left: $indent !important;\n}\n\n.info-item {\n  margin: 0;\n  padding: 0 0 $vspacing $indent;\n  list-style: none;\n}\n\n.cert_valid {\n  color: green;\n}\n\n.cert_outdated {\n  color: red;\n}\n\n.information_integrity_valid {\n  color: green;\n}\n\n.information_integrity_error {\n  color: red;\n}\n\n.information_integrity_notChecked {\n  color: gray;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
